import { createClient } from "@supabase/supabase-js";
import type { PageData } from "./page_data";

export function createSupabaseClient() {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error("Missing required Supabase environment variables");
  }

  return createClient(supabaseUrl, supabaseAnonKey);
}

export async function updatePageSettings(pageId: string, settings: PageData) {
  const supabase = createSupabaseClient();

  const { error } = await supabase
    .from("pages")
    .update({
      settings,
    })
    .eq("id", pageId);

  if (error) {
    throw new Error(`Failed to update page settings: ${error.message}`);
  }
}

export type Page = {
  id: string;
  title: string;
  path: string;
  settings: PageData;
  created_at: string;
  updated_at: string;
};
